<template>
	<div class="ss-content movie-detail-content">
		<div class="perform-box ss-container">
			<div class="perform-top">
				<div class="clearfix">
					<div class="perform__icons fr">
						<div class="operation-icon operation-icon__collection" @click="collection()"
							:class="{ active: toolObj.isCollect }"></div>
						<div class="operation-icon operation-icon__dianzan" @click="resourceUp()"
							:class="{ active: toolObj.isUp }"></div>
						<!-- <div class="operation-icon operation-icon__pinglun">{{toolObj.comments | unit}}</div> -->
					</div>
					<p class="perform__title">{{ articleData.title }}</p>
					<p class="perform__time">
						<span>{{ articleData.releaseTimestamp | time }}</span>
						<span v-if="articleData.contentExt && articleData.contentExt.contentSource">来源:
							{{ articleData.contentExt.contentSource.sourceName }}</span>
					</p>
				</div>
			</div>
			<!-- <div class="perform-middle clearfix">
				<div class="perform-middle__left">
					<div class="swiper-box" v-if="video_">
						<video class="swiper-silde__image" :src="video_ | imgUrl" controls="controls">
							your browser does not support the video tag
						</video>
					</div>
					<div class="swiper-box poster-image" v-else></div>
				</div>
				<div class="perform-middle__right">
					<p class="perform-middle__right_text article__html" v-html="articleData.txt"></p>
				</div>
			</div> -->
			<template v-if="videos_.length == 0 && video_.length == 0">
					<div class="perform-middle__right">
						<p class="perform-middle__right_text article__html" v-html="articleData.txt"></p>
					</div>
			</template>
			<template v-else-if="video_.length > 0">
				<div class="perform-middle clearfix">
					<div class="perform-middle__left">
						<div class="swiper-box" v-if="video_.length">
							<slick ref="slick" :options="slickOptions">
								<div class="swiper-silde" v-for="(item, index) in video_" :key="index"
									data-id="item.id">
									<video class="swiper-silde__image" :src="item | imgUrl" controls="controls"
										@mouseenter="handleEnter(true)" @mouseleave="handleEnter(false)">
										your browser does not support the video tag
									</video>
								</div>
							</slick>
						</div>
						<div class="swiper-box poster-image" v-else></div>
					</div>
					<div class="perform-middle__right">
						<p class="perform-middle__right_text article__html" v-html="articleData.txt"></p>
					</div>
				</div>
			</template>
			<template v-else-if="videos_.length > 0">
				<div class="perform-middle clearfix">
					<div class="perform-middle__left">
						<div class="swiper-box" v-if="videos_.length">
							<slick ref="slick" :options="slickOptions">
								<div class="swiper-silde" v-for="(item, index) in videos_" :key="index"
									data-id="item.id">
									<video class="swiper-silde__image" :src="item.url | imgUrl" controls="controls"
										@mouseenter="handleEnter(true)" @mouseleave="handleEnter(false)">
										your browser does not support the video tag
									</video>
									<div class="swiper-silde__mask clearfix" v-if="showPage">
										<div class="swiper-silde__num">
											<span>{{ index + 1 }}</span> / {{ videos_.length }}
										</div>
										<div class="swiper-silde__text" v-if="item.description">{{ item.description }}
										</div>
									</div>
								</div>
							</slick>
						</div>
						<div class="swiper-box poster-image" v-else></div>
					</div>
					<div class="perform-middle__right">
						<p class="perform-middle__right_text article__html" v-html="articleData.txt"></p>
					</div>
				</div>
				<div class="ss-recmd-box-2 mt40" v-if="videos_.length">
					<div class="ss-recmd__title">播放列表</div>
					<ul class="ss-recmd-list clearfix">
						<li v-for="(item, index) in videos_" :key="item.id" @click="swiperGoTo(index)">
							<img :src="item.cover | imgUrl" class="ss-recmd__image poster-image" />
							<div class="ss-recmd__tips">第{{ index + 1 }}集 {{ item.description }}</div>
						</li>
					</ul>
				</div>
			</template>
		

			<div class="ss-recmd-box-2 mt40" v-if="recmdList.length">
				<div class="ss-recmd__title">
					<div class="fr" @click="indexNews">
						<img src="~@/assets/img/main/gengxin.png" />换一批
					</div>
					相关推荐
				</div>
				<ul class="ss-recmd-list clearfix">
					<li v-for="(item, index) in recmdList" :key="index" @click="goDetail(item.id)">
						<img :src="item.url | imgUrl" class="ss-recmd__image poster-image" />
						<div class="ss-recmd__tips">{{ item.title }}</div>
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>
<style>
.article__html video {
	max-width: 100% !important;
}
</style>
<script>
import Slick from 'vue-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import articleDetailMixin from '@/mixins/articleDetail.js'
export default {
	mixins: [articleDetailMixin],
	name: 'culturalInfoDetail',
	components: {
		Slick
	},
	data() {
		return {
			pageSize: 12,
			recmdList: [],
			showPage: true,
			slickOptions: {
				infinite: true,
				arrows: true,
				dots: false,
				slidesToShow: 1,
				slidesToScroll: 1,
				autoplaySpeed: 5e3,
			}
		}
	},
	created() {
		this.indexNews();
	},
	methods: {
		handleEnter(hidPage) {
			this.showPage = !hidPage
		},
		goDetail(id) {
			this.$router.push({
				path: '/brilliantEHome/show/' + id
			})
		},
		swiperGoTo(index) {
			this.$refs.slick.goTo(index);
		},
		async indexNews() {
			let res = await this.$http('indexNews', {
				channelPaths: 'jcycbs,jcyczy,jcyccgzs,jcycdxfy,jcycqt',
				count: 5
			});
			res.code === 1 && (this.recmdList = res.data || []);
		},
	}
}
</script>

<style lang="scss" scoped="scoped">
@import '~@/assets/css/movie-detail.scss';
</style>
